<template>
  <div class="todo" style="">
    <div class="title" style="">
      <IconFont type="icon-daibanshixiang" class="iconFont" style="" />
      <span class="span" style="">{{ pageType }}</span>
      <a-input-search
        class="input"
        placeholder="请输入关键字搜索"
        v-model="value"
        style=""
        @search="onSearch"
      />
    </div>
    <div class="table" style="">
      <a-table
        :columns="columns"
        :data-source="data"
        @change="changePage"
        :loading="loading"
        :pagination="pagination"
        :rowKey="(record) => record.report_message_id"
      >
        <span slot="name" slot-scope="text">{{ text }}</span>
        <span slot="action" slot-scope="text">
          <a @click="goToForm(text)">查看</a>
          <!--<a-divider type="vertical" />-->
          <!--<a>编辑</a>-->
          <!--<a-divider type="vertical" />-->
          <!--<a >审批 </a>-->
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import { service } from './service'
import './style.less'
const columns = [
  {
    title: '公告名称',
    dataIndex: 'report_message_name',
    key: 'report_message_name',
    width: 500,
    ellipsis: true
  },
  {
    title: '创建人',
    dataIndex: 'drafter_name',
    key: 'drafter_name'
  },
  {
    title: '创建日期',
    dataIndex: 'report_message_create_time',
    key: 'report_message_create_time',
    ellipsis: true
  },
  {
    title: '操作',
    key: 'action',
    width: '160px',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  name: 'Index',
  data() {
    return {
      title: '待办', // title
      loading: true,
      pageType: '内部公告', // 页面类型
      columns, // 列表头
      status: 'Dealt', // 流程状态
      value: '', // input框的值
      data: [], // 列表数据],
      pagination: {
        current: 1,
        pageSize: 18,
        total: 0,
        showTotal: (total) => `共 ${total} 条数据`
      }
    }
  },
  created() {
    this.pageType = '内部公告'
    if (this.$route.query && this.$route.query.pageType) {
      // 判断页面跳转带过来的页面类型的值
      if (this.$route.query.pageType === 'inside') {
        this.pageType = '内部公告'
      } else if (this.$route.query.pageType === 'government') {
        this.pageType = '政府公告'
      }
    }
  },
  mounted() {
    this.getProcessList({
      report_message_type: this.pageType,
      pageIndex: 1,
      pageSize: this.pagination.pageSize
    })
  },
  methods: {
    // 分页切换
    changePage(pagination) {
      this.pagination.current = pagination.current
      this.getProcessList({
        report_message_type: this.pageType,
        report_message_name: this.value,
        pageIndex: pagination.current,
        pageSize: this.pagination.pageSize
      })
    },
    // input查询
    onSearch() {
      this.getProcessList({
        report_message_type: this.pageType,
        report_message_name: this.value,
        pageIndex: 1,
        pageSize: this.pagination.pageSize
      })
    },
    goToForm(data) {
      const params = {
        process_base_work_number: data.process_base_work_number,
        process_base_status: data.process_base_status
      }
      this.$router.push({
        path: '/assit/contentManagement/increaseReport',
        query: { pageType: 'view', processData: JSON.stringify(params) }
      })
    },
    // 获取流程列表
    getProcessList(data) {
      this.loading = true
      service.reportMessageForPage(data).then((response) => {
        this.data = response.data || []
        this.pagination.total = response.total || 0
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style.less';
</style>
